import React, { useContext } from 'react'
import { ChangePresentContext, MedPlanContext } from '../../SingleEvent'
import Grid from '@mui/material/Grid'
import DestinationPicker from './DestinationPicker'

const NearestPPCI = ({ destinationOptions, loadOptions }) => {
  const { medPlan, setMedPlan } = useContext(MedPlanContext)
  const { changesPresent, setChangesPresent } = useContext(ChangePresentContext)

  return (
    <Grid item xs={12} lg={4}>
      <DestinationPicker
        value={medPlan?.nearestPPCI ?? null}
        loadOptions={loadOptions}
        label="Nearest PPCI"
        type="PPCI"
        destinationOptions={destinationOptions}
        onChange={(e, newValue) => {
          setMedPlan((prev) => ({
            ...prev,
            nearestPPCI: newValue,
          }))
          !changesPresent && setChangesPresent(true)
        }}
        onEditSubmit={(newValue) => {
          setMedPlan((prev) => ({
            ...prev,
            nearestPPCI: newValue,
          }))
          !changesPresent && setChangesPresent(true)
        }}
      />
    </Grid>
  )
}

export default React.memo(NearestPPCI)
